import { HyperionAddress, Maybe, OrderAddress } from '__generated__/atlas-types'

// The order address does not have an id in the BE, therefore we can only know if it's already included
// in the array by checking if there's an array element such as all its fields' value match with the order address ones
export const isOrderAddressIncluded = (
  addresses: (Maybe<HyperionAddress> | undefined)[],
  orderAddress: OrderAddress | undefined,
): boolean =>
  addresses.some(
    (address) =>
      address?.city === orderAddress?.city &&
      address?.country === orderAddress?.country &&
      address?.line1 === orderAddress?.firstAddress &&
      address?.line2 === orderAddress?.secondAddress &&
      address?.state === orderAddress?.state &&
      address?.zip === orderAddress?.zip &&
      address?.name === orderAddress?.name &&
      address?.companyName === orderAddress?.company,
  )
